import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "@activecollab/components";
import PropTypes from "prop-types";

export const GoogleDriveButton = React.forwardRef(({ url, variant }, ref) => {
  const { t } = useTranslation();
  return (
    <Link
      ref={ref}
      href={url}
      className="btn btn--pro-2"
      target="_blank"
      rel="noreferrer"
      variant={variant}
    >
      {t("View in Google Drive")}
    </Link>
  );
});

GoogleDriveButton.propTypes = {
  url: PropTypes.string,
  variant: PropTypes.string,
};

GoogleDriveButton.defaultProps = {
  url: "#",
  variant: "primary",
};

GoogleDriveButton.displayName = "GoogleDriveButton";
